// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ProjectTemplateSchema } from './v1/projectTemplateSchema';
import { v1ProjectTemplatesUpdateSchema } from './v1/projectTemplates/updateSchema';

export const updateProjectTemplatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Project template ID"),
});

export const updateProjectTemplateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project template updated successfully
 */
export const updateProjectTemplate200Schema = z.lazy(() => v1ProjectTemplateSchema);

export const updateProjectTemplateMutationRequestSchema = z.lazy(() => v1ProjectTemplatesUpdateSchema);

export const updateProjectTemplateMutationResponseSchema = z.lazy(() => updateProjectTemplate200Schema);
